import { render, staticRenderFns } from "./m_company009.vue?vue&type=template&id=6a42f27a&"
import script from "./m_company009.vue?vue&type=script&lang=js&"
export * from "./m_company009.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports